module.exports = __webpack_public_path__ + "static/img/5.019795e.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/3/1/zh/5.png
// module id = udq5
// module chunks = 0